import atoms from "../../../components/atoms";
import { TDeliverForm } from "./interface";

const { Select } = atoms;



const DeliverForm = ({barcodeList,handleChange}:TDeliverForm) => {
    return (
        <div className="mt-3">
            <Select
                className={"w-100"}
                options={barcodeList}
                onChange={(e: any) => handleChange(e)}
                placeholder={"Select"}
                label={"Select Barcode"}
            />
        </div>
    );
};

export default DeliverForm;
